module.exports = __webpack_public_path__ + "media/images/ui__textCross--dark-fad0f4d29ef8d4b0cffbb5e9b2c5b2cd.png";